// eslint-disable-next-line no-restricted-imports
import type { CSSObject } from '@emotion/react';
// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { spacing } from '@iheartjane/reefer-emotion';
import type { ReactNode } from 'react';
import { Children, isValidElement, useState } from 'react';

import { TextFieldProvider } from './text-field-context';
import type { Variant } from './text-input';

type ContainerProps = {
  variant?: Variant;
};

const material: CSSObject = {
  position: 'relative',
  display: 'inline-flex',
  flexDirection: 'column',
  minWidth: 0,
  width: '100%',
  ...spacing({ mb: 4 }),
};

const Container = styled.div<ContainerProps>((props) => {
  switch (props.variant) {
    case 'material':
      return material;

    default:
      return {};
  }
});

interface FieldControlProps {
  children: ReactNode;
  error?: boolean;
  isFocused?: boolean;
  success?: boolean;
  variant?: Variant;
}

export const FieldControl = ({
  children,
  variant = 'material',
  isFocused = false,
  error = false,
  success = false,
}: FieldControlProps) => {
  const [isShrunk] = useState(() => {
    let shrink = false;

    if (children) {
      Children.forEach(children, (child) => {
        if (!isValidElement(child)) return;
        if (child.props.defaultValue || child.props.value) {
          shrink = true;
        }
      });
    }

    return shrink;
  });

  return (
    <TextFieldProvider
      isShrunk={isShrunk}
      variant={variant}
      error={error}
      success={success}
      isFocused={isFocused}
    >
      <Container variant={variant}>{children}</Container>
    </TextFieldProvider>
  );
};
